// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__19n_m","title":"Info_title__2mWly","links":"Info_links__1T9ij","link":"Info_link__DFY3d","logo":"Info_logo__3Niay"};